import React from 'react';
import SearchIcon from '@mui/icons-material/Search';
import { useTeacherSearchContext } from '../../../providers/TeacherSearchProvider';
import { verticalCopy } from '../../../utils/constants/verticalCopy';
import './SearchButton.css';

interface SearchButtonProps {
  onClick: () => void;
}

const SearchButton: React.FC<SearchButtonProps> = ({ onClick }) => {
  const { selectedInstitution, selectedCourse, searchType } = useTeacherSearchContext();
  const copy = verticalCopy[searchType === 'all' ? 'university' : searchType];
  const institutionPlaceholder = copy.institutionLabel;
  const coursePlaceholder = copy.courseLabel;

  return (
    <div className="searchButtonContainer" onClick={onClick}>
      <div className="searchIconContainer">
        <SearchIcon className="searchIcon" />
      </div>
      <div className="searchButtonSection">
        <span
          className={`searchButtonValue ${selectedInstitution?.label ? 'boldText' : 'normalText'}`}>
          {selectedInstitution?.label ? selectedInstitution.label : institutionPlaceholder}
        </span>
      </div>
      <div className="searchButtonDivider" />
      <div className="searchButtonSection">
        <span className={`searchButtonValue ${selectedCourse?.label ? 'boldText' : 'normalText'}`}>
          {selectedCourse?.label ? selectedCourse.label : coursePlaceholder}
        </span>
      </div>
    </div>
  );
};

export default SearchButton;
